import { render, staticRenderFns } from "./EnvelopeTemplateModal.vue?vue&type=template&id=dcbbab5c"
import script from "./EnvelopeTemplateModal.vue?vue&type=script&lang=js"
export * from "./EnvelopeTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports